import dataModel from '../../models/DataModel.js';
import teamsService from '../../services/teamsService';
import AOCollection from './AOCollection';
import ReduxConstants from '../../constants/ReduxConstants.js';

export const teams_root = {
  team: {},
};

export default class TeamsCollection extends AOCollection {
  constructor(companyId, marketId) {
    super({
      name: ReduxConstants.TEAMS,
      collectionType: ReduxConstants.TEAM,
      companyId, 
      subKey: marketId,
    });
  }

  static build(name, companyId, marketId) {
    let collection = new TeamsCollection(companyId, marketId);
    let collectionData = dataModel.collectionsDAO.findCollection(collection.getKey());
    if (!collectionData) {
      collectionData = collection.getDefaultData();
      collectionData = dataModel.collectionsDAO.setCollection(collection.getKey(), collectionData, collection.getCollectionType());
    }
    return collection;
  }

  handleOffLineFetch(options) {

    return new Promise((resolve) => {
      let denormalizedCollection = this.getDenormalizedCollection(options);
      resolve(denormalizedCollection.teams);
    });
  }

  async fetchCurrent(shouldPaginate = true, options = {}, prefetchCallback) {
    if (!options.recordDescriptor) {
      options.recordDescriptor = this.recordDescriptor;
    }
    if (dataModel.isOffline) {
      return this.handleOffLineFetch(options);
    }
    else {
      return new Promise(async (resolve) => {
        let serviceCall = teamsService.getTeams.bind(this, localStorage.current_company_id, this.subKey, options);

        let newCollection = await this._fetchData(serviceCall, options, false, null, prefetchCallback);
        if (newCollection.offline) {
          return this.handleOffLineFetch(options);
        }

        return resolve(newCollection);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/collections/TeamsCollection.js